var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page position-relative mb-5"},[_c('div',{staticClass:"banner"},[_c('responsive-img',{attrs:{"img":_vm.img,"alt":_vm.alt,"ratio":"16:9"}})],1),_c('b-container',{attrs:{"fluid":true}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }